export default __webpack_public_path__ + "static/media/img2.eead1c5f.png";